interface ProgressRingProps {
  value: number;
  label: string;
  caption: string;
}

export function ProgressRing({ value, label, caption }: ProgressRingProps) {
  const clamped = Math.max(0, Math.min(100, value));

  return (
    <div className="progress-ring">
      <svg className="progress-ring-svg" viewBox="0 0 36 36" aria-hidden="true">
        <circle className="progress-ring-track" cx="18" cy="18" r="15.5" />
        <circle className="progress-ring-value" cx="18" cy="18" r="15.5" pathLength={100} strokeDasharray={`${clamped} 100`} />
      </svg>
      <div className="progress-ring-copy">
        <strong>{label}</strong>
        <span>{caption}</span>
      </div>
    </div>
  );
}
